import ContainerItem from '../../item/containerItem';
import CutangleItem from '../../item/cutangleItem';
import SolvableInterface from '../problem/solvableInterface';

/**
 * @class ValidatorView
 */
export default class BadgeView {
    badges = new Map();
    itemToTypeMap = new Map();

    constructor(overlayManager) {
        this.overlayManager = overlayManager;
    }

    updateView(problems) {
        this.badges.forEach((badges, problem) => this._removeBadges(problem));
        this.badges.clear();
        this.itemToTypeMap.clear();
        problems.forEach(problem => this._addBadges(problem));
        this._fixBadgeOffsets();
    }

    _addBadges(problem) {
        problem.getItems().forEach((item) => {
            // Never show badges on ContainerItems unless they are the only item for this problem
            if (item instanceof ContainerItem && problem.getItems().length > 1) return;

            // Never show badges for CutangleItems as they don't have a useful position
            if (item instanceof CutangleItem) return;

            // Items should only have one badge per type
            if (!this.itemToTypeMap.has(item)) this.itemToTypeMap.set(item, new Set());
            if (this.itemToTypeMap.get(item).has(problem.type)) return;
            this.itemToTypeMap.get(item).add(problem.type);

            // Create the badge
            const badge = this._createBadgeForProblem(problem, item);
            if (!this.badges.has(problem)) this.badges.set(problem, new Map());
            this.badges.get(problem).set(item, badge);

            // Show the badge
            this.overlayManager.add(badge);

            // Update the badge position if the item position changes
            item
                .getAncestorsAndSelf()
                .forEach(ancestor => ancestor.on('change:position', () => {
                    const { x, y } = item.getAbsolutePosition();
                    badge.setPosition(x, y);
                }, badge));
        });
    }

    _removeBadges(problem) {
        const badges = this.badges.get(problem);

        badges.forEach(badge => this.overlayManager.remove(badge));
        this.badges.delete(problem);

        badges.forEach((badge, item) => {
            item.getAncestorsAndSelf().forEach(subItem => subItem.off('change:position', null, badge));
        });
    }

    _createBadgeForProblem(problem, item) {
        if (SolvableInterface.isImplementedBy(problem)) {
            return new Ofcs.Editor.Canvas.Overlay.ClickableBadgeOverlay(
                item.getAbsolutePosition(),
                (...args) => problem.solve(...args),
                {
                    title: problem.getMessage(),
                    icon: problem.getIcon(),
                    type: problem.getBadgeType(),
                    item,
                    fixToItem: true,
                },
            );
        }

        return new Ofcs.Editor.Canvas.Overlay.BadgeOverlay(
            item.getAbsolutePosition(),
            {
                title: problem.getMessage(),
                icon: problem.getIcon(),
                type: problem.getBadgeType(),
                item,
                fixToItem: true,
            },
        );
    }

    _fixBadgeOffsets() {
        const badgesByItem = new Map();
        const badgeWidth = 24;
        const badgeMargin = 2;

        this.badges.forEach((badges) => {
            badges.forEach((badge, item) => {
                if (!badgesByItem.has(item)) badgesByItem.set(item, []);
                badgesByItem.get(item).push(badge);
            });
        });

        badgesByItem.forEach((badges) => {
            const totalMargin = (badges.length - 1) * badgeMargin;
            const totalBadgeWidth = (badges.length - 1) * badgeWidth;
            const startOffset = (totalBadgeWidth + totalMargin) / -2;

            badges.forEach((badge, index) => {
                badge.setPxOffset(startOffset + (index * badgeWidth) + (index * badgeMargin), 0);
            });
        });
    }
}
